import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { CONFIGURATION } from "../../app.constants";
import { Observable } from "rxjs/Observable";
import { HttpDataService } from "./httpData.service";
import { Diocese, Organisation } from "../../models";

@Injectable()
export class CommonDataService {

    constructor(private httpData: HttpDataService) { }

    public GetDioceseList(): Observable<Diocese[]> {
        let order: string = "$orderby=DioceseName asc";
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}v1/EF/SearchDiocese?${{order}}`;
        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .map(response => <Diocese[]>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public GetOrganisationsByDioceseId(dioceseId: number): Observable<Organisation[]> {
        const enterpriseConnectionName = ""; // Return All organisations until Auth0 connectionName issue is rectified""
        let enterpriseConnectionNameParam: string = enterpriseConnectionName ? `&enterpriseConnectionName=${encodeURIComponent(enterpriseConnectionName)}` : "";    
        
        let select: string = "$select=PublicId,Name,LocationSuburb,LocationPostCode,ExternalId";
        let filter: string = `&$filter=DioceseId eq ${dioceseId} and IsActive eq true`;
        let order: string = "&$orderby=Name";
               
        let dataUrl = CONFIGURATION.baseUrls.apiUrl + "v1/EF/SearchOrganisation?" + select + filter + order + enterpriseConnectionNameParam;

        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .map(response => <Organisation[]>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public GetBanner(): Observable<Response> {

        return Observable.create((observer) => {
            this.httpData.get(CONFIGURATION.baseUrls.apiUrl + "common/GetBanner")
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/services/shared/commonData.service.ts